module.exports = __webpack_public_path__ + "img/baizhi-back-three@2x.bdb8c3db.png";